<p-panel header="{{ 'UNIDADESMEDIDA.LBL_CONFIGURACION' | translate }}">
  <app-loading *ngIf="carInformacionInicial"></app-loading>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <form
        [formGroup]="formulario"
        (ngSubmit)="onSubmit()"
        novalidate
        *ngIf="!carInformacionInicial"
      >
        <div class="grid form-group">
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>* {{ "UNIDADESMEDIDA.LBL_CODIGO" | translate }}</label>
              <div *ngIf="!unidadMedidaCultivo">
                <input
                  id="codigo"
                  type="text"
                  name="nomCodigo"
                  autocomplete="off"
                  pInputText
                  [maxlength]="6"
                  formControlName="codigo"
                  codigos-reactive
                />
                <div
                  class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.codigo.invalid"
                >
                  {{ "LBL_CODIGO" | translate }}
                  {{ "LBL_REQUERIDO" | translate }}
                </div>
                <div
                  class="p-message p-messages-error p-corner-all"
                  *ngIf="codigoRepetido"
                >
                  {{ "UNIDADESMEDIDA.LBL_CODIGORELACIONADO" | translate }}
                </div>
              </div>
              <div *ngIf="unidadMedidaCultivo">
                <label class="falso-combo-texto">{{
                  unidadMedidaCultivo.codigo
                }}</label>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label
                >* {{ "UNIDADESMEDIDA.LBL_UNIDADMEDIDA" | translate }}</label
              >
              <input
                id="nombre"
                type="text"
                pInputText
                [maxlength]="50"
                placeholder="{{
                  'UNIDADESMEDIDA.LBL_UNIDADMEDIDA' | translate
                }}"
                formControlName="nombre"
              />
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.nombre.invalid"
              >
                {{ "LBL_CODIGO" | translate }} {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label
                >* {{ "UNIDADESMEDIDA.LBL_EQUIVALENCIA" | translate }}</label
              >
              <input
                id="valorUnidadMedida"
                type="text"
                pInputText
                [maxlength]="8"
                placeholder="{{
                  'UNIDADESMEDIDA.LBL_EQUIVALENCIA' | translate
                }}"
                formControlName="valorUnidadMedida"
                numero-decimal-reactive
                [decimales]="2"
                [entero]="5"
              />
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.valorUnidadMedida.invalid"
              >
                {{ "LBL_CODIGO" | translate }} {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
          </div>
        </div>

        <div class="grid form-group">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form text-center">
              <p-checkbox
                label="{{ 'LBL_HABILITADO' | translate }}"
                binary="true"
                id="indicadorHabilitado"
                name="nomIndicadorHabilitado"
                formControlName="indicadorHabilitado"
              ></p-checkbox>
            </div>
          </div>
        </div>

        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guardando">
              <a (click)="regresar()" class="cancelar">{{
                "BTN_CANCELAR" | translate
              }}</a>
              <button
                icon="fa fa-floppy-o"
                label="{{ 'BTN_GUARDAR' | translate }}"
                type="submit"
                pButton
              ></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
              <span>{{ "LBL_GUARDANDO" | translate }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-panel>

<p-confirmDialog #cd key="unidad-medida-form">
  <p-footer>
    <button
      type="button"
      pButton
      icon="fa fa-close"
      label="{{ 'LBL_NO' | translate }}"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      pButton
      icon="fa fa-check"
      label="{{ 'LBL_SI' | translate }}"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>
